import styled, { css } from 'styled-components'
import { size } from '../../../utils/constants'
import { X as LucideX } from 'lucide-react'

export const ModalOverlay = styled.div`
  position: relative;
  background: white;
  padding: 15px 15px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  text-align: center;
  width: 100%;
  max-width: 100%;
  margin: 10px auto;
  box-sizing: border-box;

  /* default (closed) */
  opacity: 0;
  display: none;
  transition:
    opacity 150ms ease-out,
    display 150ms,
    overlay 150ms;
  transition-behavior: allow-discrete;

  ${({ $open }) =>
    $open &&
    css`
      display: block;
      @starting-style {
        opacity: 0;
      }
      opacity: 1;
    `};
  margin: 10px auto;
  width: calc(100% - 20px);
`

export const ModalContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 15px;
  position: relative;

  opacity: 0;
  display: none;
  transition:
    opacity 150ms ease-out,
    display 150ms,
    overlay 150ms;
  transition-behavior: allow-discrete;

  ${({ $open }) =>
    $open &&
    css`
      display: flex;
      @starting-style {
        opacity: 0;
      }
      opacity: 1;
    `};
`

export const CloseIcon = styled(LucideX)`
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  width: 18px;
  height: 18px;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`

export const DarkOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  opacity: 0;
  display: none;
  transition:
    opacity 150ms ease-out,
    display 150ms,
    overlay 150ms;
  transition-behavior: allow-discrete;

  ${({ $open }) =>
    $open &&
    css`
      display: block;
      @starting-style {
        opacity: 0;
      }
      opacity: 1;
    `};
`

export const ShareModalChatForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
  & > * {
    width: 100%;
  }
`

export const StatusMessage = styled.div`
  margin-top: 8px;
  margin-bottom: -8px;
  min-height: 20px; /* reserve space to prevent layout shift */
  text-align: center;
  font-size: 14px;
  color: ${({ $status }) =>
    $status === 'success'
      ? 'green'
      : $status === 'error'
      ? 'red'
      : 'transparent'};
  transition: color 0.2s ease;
`
